import templatelyLogo from './assets/templately.svg';
import rightIcon from './assets/Vector.png';
import TooltipComponent from '../../../utils/TooltipComponent';

export function Templately({ month = 1 }) {
	return (
		<>
			<form>
				<label
					htmlFor="FreeCard"
					className="wp-checkout-flex wp-checkout-flex-space-between wp-checkout-templately-free-card "
				>
					<div className="full-width wp-checkout-flex">
						<div className="wp-checkout-card-left-content">
							<img src={templatelyLogo} />
						</div>
						<div className="wp-checkout-card-right-content">
							<div className="wp-checkout-flex wp-checkout-flex-space-between">
								<h3 className="wp-checkout-font-lg wp-checkout-product-card-title">
									Templately
									<span className="wp-checkout-font-sm wp-checkout-free-tag">
										Included for Free
										<TooltipComponent tooltipText="Ultimate Free Templates Cloud for WordPress with 4,000+ Templates – Elementor & Gutenberg Supported">
											<span>
												<svg
													width="14"
													height="14"
													viewBox="0 0 14 14"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<g clipPath="url(#clip0_1718_187)">
														<path
															d="M1.75 7C1.75 7.68944 1.8858 8.37213 2.14963 9.00909C2.41347 9.64605 2.80018 10.2248 3.28769 10.7123C3.7752 11.1998 4.35395 11.5865 4.99091 11.8504C5.62787 12.1142 6.31056 12.25 7 12.25C7.68944 12.25 8.37213 12.1142 9.00909 11.8504C9.64605 11.5865 10.2248 11.1998 10.7123 10.7123C11.1998 10.2248 11.5865 9.64605 11.8504 9.00909C12.1142 8.37213 12.25 7.68944 12.25 7C12.25 5.60761 11.6969 4.27226 10.7123 3.28769C9.72774 2.30312 8.39239 1.75 7 1.75C5.60761 1.75 4.27226 2.30312 3.28769 3.28769C2.30312 4.27226 1.75 5.60761 1.75 7Z"
															stroke="#0077A3"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
														<path
															d="M7 5.25H7.00833"
															stroke="#0077A3"
															strokeWidth="1.5"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
														<path
															d="M6.41797 7H7.0013V9.33333H7.58464"
															stroke="#0077A3"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
													</g>
													<defs>
														<clipPath id="clip0_1718_187">
															<rect
																width="14"
																height="14"
																fill="white"
															/>
														</clipPath>
													</defs>
												</svg>
											</span>
										</TooltipComponent>
									</span>
								</h3>

								<div className="free-card-icon-wrapper">
									<img
										src={rightIcon}
										alt=""
									/>
								</div>
							</div>
							<p className="wp-checkout-font-sm wp-checkout-free-card-sub-header">
								Templately{' '}
								<span>
									PRO {month} {month > 1 ? 'Months' : 'Month'}{' '}
									FREE
								</span>{' '}
								Subscription
							</p>
						</div>
					</div>
				</label>
			</form>
		</>
	);
}
